
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./../../bootstrap');

import axios from 'axios';
axios.defaults.baseURL = window.base_url;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]').content;
axios.defaults.headers.common['Authorization'] = `Bearer ${ document.querySelector('meta[name="api-token"]').content }`;
window.axios = axios;

window.Vue = require('vue').default;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Vue.component('example-component', require('./components/ExampleComponent.vue'));

import VueRouter from 'vue-router';
Vue.use(VueRouter);

import Vuex from 'vuex';
Vue.use(Vuex);

import _ from 'lodash';

import store from './root.vuex';
import App from './vue/App';
import Loader from '../Loader';

Vue.component('Loader', Loader);

import VueInternationalization from 'vue-i18n';
import Locale from './../../vue-i18n-locales.generated.js';

const lang = document.documentElement.lang.substr(0, 2); 

Vue.use(VueInternationalization);
const i18n = new VueInternationalization({
    locale: lang,
    messages: Locale
});

import Notifications from 'vue-notification';
Vue.use(Notifications);

const app = new Vue({
    el: '#app',
	i18n,
	store: store, 
    components: {
        App
    },
}).$mount('#app');

